import React, {useState} from 'react';
import {Col, Row} from "reactstrap";

export default function LangLabelRow(props) {

    // Este componente se renderiza en el listado principal

    const [row] = useState(props.row);

    return (
        <div className={"labels-table"}>
            {
                row.langs.length > 0 ?
                    row.langs.sort((a, b) => a.lang?.showOrder - b.lang?.showOrder ).map((langLabel, index) => {
                        return (
                            <Row className={"labels-table-row"} key={"ll" + index }>
                                <Col md={"2"} >
                                    <h4>{ langLabel?.nativeName }</h4>
                                </Col>
                                <Col md={"10"} >
                                    <p>{langLabel.name}</p>
                                </Col>
                            </Row>
                        );
                    }) : null
            }
        </div>
    )
}